 import { Button, Card, Checkbox, Col, Collapse, CollapseProps, Empty, Flex, Form, FormProps, Input, InputNumber, Modal, notification, Row, Select, Table, theme } from "antd";
import { CSSProperties, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ImpactsInterface, OutcomeDefinition, OutcomeInterface, OutputDefinition, OutputInterface, PartFourInterface } from "../models/Result";
import { CaretRightOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import { SplitText } from "./functionLater";
import { SpellCheck } from "lucide-react";
import Item from "antd/es/list/Item";

const { TextArea } = Input;

const impacts = [
  { key: "academic", label: "ด้านวิชาการ", name: "academic_impacts" },
  { key: "social", label: "ด้านสังคม", name: "social_impacts" },
  { key: "publicSo", label: "ด้านสาธารณะ", name: "public_impacts" },
  { key: "city", label: "ด้านชุมชนและพื้นที่", name: "city_impacts" },
  { key: "environment", label: "ด้านสิ่งแวดล้อม", name: "environment_impacts" },
  { key: "policy", label: "ด้านนโยบาย", name: "policy_impacts" },
  { key: "economy", label: "ด้านเศรษฐกิจ", name: "economy_impacts" },
];


export function BudgetReqResult(){
    const [selectedImpacts, setSelectedImpacts] = useState<Record<string, boolean>>({});
    const [form] = Form.useForm();
    const [Success,setSuccess] = useState(false)
    //ผลผลิต
    const [Output,setOutput] = useState<OutputInterface[]>([])
    const [Outputdescription,setOutputDescription] = useState<OutputDefinition[]>([])
    //ผลลัพธ์
    const [Outcome,setOutcome] = useState<OutcomeInterface[]>([])
    const [Outcomedescription,setOutcomedescription] = useState<OutcomeDefinition[]>([])
    
    const { token } = theme.useToken();
    const [destination, setdestination] = useState('')

    //ผลกระทบ
    const [Academic,SetAcademic] = useState(false);
    const [Social,SetSocial] = useState(false);
    const [PublicSo,SetPublicSo] = useState(false);
    const [City,SetCity] = useState(false);
    const [Environment,SetEnvironment] = useState(false);
    const [Policy,SetPolicy] = useState(false);
    const [Economy,SetEconomy] = useState(false);    
    const [open,setopen] = useState(false)

    const handleCancel = ()=>{
        setopen(false)
      }

      const handleCheckboxChange = (key: string) => {
        setSelectedImpacts((prev) => ({ ...prev, [key]: !prev[key] }));
      };

    const getItems: (panelStyle: CSSProperties) => CollapseProps['items'] = (panelStyle) => [
        {
          key: '1',
          label: 'ประเภทของผลผลิตและคำจำกัดความ (Type of Outputs and Definition)',
          children: <><p style={{marginBottom:20}}>นิยามของผลผลิต คือ ผลผลิตที่เกิดขึ้นจากการวิจัยที่ได้รับการจัดสรรทุนวิจัยจากมหาวิทยาลัยวงษ์ชวลิตกุล  โดยเป็นผลที่เกิดขึ้นทันทีเมื่อจบโครงการ และเป็นผลโดยตรงจากการดำเนินโครงการ </p>
          <Table 
          pagination={false}
          columns={
            [{
                title: <Flex justify='center'><p>ประเภทของผลผลิต<br/> (Type of Outputs)</p></Flex>,
                width:350,
                dataIndex:'output_name'
          },{
                title: <Flex justify='center'><p>คำจำกัดความ (Definition)</p></Flex>,
                dataIndex:'output_definition',
                render: (_, record) => (
                    <>
                    <SplitText text={record.output_definition}/>
                    </>
                )
          }
          ]} dataSource={Outputdescription}
          />
          </>,
          style: panelStyle,
        },
      ];
    const getOutcomes: (panelStyle: CSSProperties) => CollapseProps['items'] = (panelStyle) => [
        {
          key: '1',
          label: 'ประเภทของผลลัพธ์และคําจํากัดความ (Type of Outcomes and Definition)',
          children: <><p style={{marginBottom:20}}>นิยามของผลลัพธ์ คือ ผลที่เกิดขึ้นหลังจากโครงการวิจัยสิ้นสุดไปแล้ว โดยเป็นการนําผลผลิต (Output) ที่ได้ของโครงการพัฒนาวิจัยและนวัตกรรม ไปใช้ประโยชน์โดยผู้ใช้ (Users) ที่ชัดเจน ส่งผลทำให้ระดับความรู้ ทัศนคติ พฤติกรรม การปฏิบัติ หรือทักษะของผู้ใช้มีการเปลี่ยนแปลงไปจากเดิมเมื่อเทียบกับก่อนการนําผลผลิตจาก โครงการมาใช้ รวมถึงการใช้ประโยชน์จากผลผลิตของโครงการที่เป็นทั้งผลิตภัณฑ์ การบริการ และเทคโนโลยี โดยภาคเอกชนหรือประชาสังคม ตลอดจนการพัฒนาต่อยอดผลผลิตของโครงการเดิมที่ยังไม่เสร็จสมบูรณ์ ให้มี ระดับความพร้อมในการใช้ประโยชน์สูงขึ้นอย่างมีนัยสําคัญ</p>
          <Table 
          pagination={false}
          columns={
            [{
                title: <Flex justify='center'><p>ประเภทของผลลัพธ์<br/>(Types of Outcomes)</p></Flex>,
                width:350,
                dataIndex:'outcome_name'
          },{
                title: <Flex justify='center'><p>คำจำกัดความ (Definition)</p></Flex>,
                dataIndex:'outcome_definition',
                render: (_, record) => (
                    <>
                    <SplitText text={record.outcome_definition}/>
                    </>
                )
          }
          ]} dataSource={Outcomedescription}
          />
          </>,
          style: panelStyle,
        },
      ];

    const { project_id } = useParams();
    const navigate = useNavigate();

    const getData = async()=>{
        try{axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${sessionStorage.getItem('user')}`).then(response=>{
            console.log(response.data.main)
            if(response.data.main[0].output&&response.data.main[0].outcome&&response.data.main[0].impacts){
                setOutput(JSON.parse(response.data.main[0].output))
                setOutcome(JSON.parse(response.data.main[0].outcome))
              }
          
            if(response.data.main[0].impacts){
                const tmp = JSON.parse(response.data.main[0].impacts)
                form.setFieldsValue(tmp)
                if(JSON.parse(response.data.main[0].impacts).academic_impacts){
                    SetAcademic(true)
                }
                if(JSON.parse(response.data.main[0].impacts).social_impacts){
                    SetSocial(true)
                }
                if(JSON.parse(response.data.main[0].impacts).public_impacts){
                    SetPublicSo(true)
                }
                if(JSON.parse(response.data.main[0].impacts).city_impacts){
                    SetCity(true)
                }
                if(JSON.parse(response.data.main[0].impacts).environment_impacts){
                    SetEnvironment(true)
                }
                if(JSON.parse(response.data.main[0].impacts).policy_impacts){
                    SetPolicy(true)
                }
                if(JSON.parse(response.data.main[0].impacts).economy_impacts){
                    SetEconomy(true)
                }
            }
            
        })}catch (error) {
            console.error("Error fetching data:", error);
        }
    }
    const handleFinish : FormProps<PartFourInterface>['onFinish'] = (values:any) =>{
        const TmpImpacts = {
            academic_impacts : values.academic_impacts??'',
            social_impacts : values.social_impacts??'',
            public_impacts : values.public_impacts??'',
            city_impacts : values.city_impacts??'',
            environment_impacts : values.environment_impacts??'',
            policy_impacts : values.policy_impacts??'',
            economy_impacts : values.economy_impacts??''
        }
        const data = {
            part : 'part4',
            output : JSON.stringify(Output),
            outcome : JSON.stringify(Outcome),
            impacts : JSON.stringify(TmpImpacts)
        }
        try{
            axios.patch(`${process.env.REACT_APP_BASE}/UpdateBudgetReq/${project_id}`,data)
            .then((response)=>{
                if(response.status===200){
                    setSuccess(true)
                    notification.success({message:'บันทึกสำเร็จ'})
                    navigate(destination);
                }
            })
        }catch(error){
            notification.error({
                message:'บันทึกข้อมูลไม่สำเร็จ'
            })
        }
    }

    const handleMainInfo = () =>{
        setdestination(`/VRIIS/BudgetReqInfo/${project_id}`)
    }
    const handleNextPart = () =>{
        setdestination(`/VRIIS/BudgetReqFund/${project_id}`)
    }
    const handleOutput = () =>{
        const tmpindex = Output.length
        const newObj = [...Output]
        newObj.push({
            index:tmpindex,
            Output_name:'',
            Output_type:'',
            Output_description : '',
            Output_amount : 0,
            Output_unit: ''
        })
        setOutput(newObj)
    }
    const handleOutcome = () =>{
        const tmpindex = Outcome.length
        const newObj = [...Outcome]
        newObj.push({
            index:tmpindex,
            Outcome_name:'',
            Outcome_Benefitor:'',
            Outcome_description : '',
            Outcome_amount : 0,
            Outcome_unit: ''
        })
        setOutcome(newObj)
    }
    const panelStyle: React.CSSProperties = {
        marginBottom: 24,
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: 'none',
      };

    const GetDefinition = async() =>{
        axios.get(`${process.env.REACT_APP_BASE}/outputandoutcome`).then(response=>{
            console.log(response.data)
            setOutcomedescription(response.data.outcome)
            setOutputDescription(response.data.output)
        })
    }

    // outputHandle
    const handleOutputType = (index: number, value: string) =>{
        const tmpOutput=[...Output]
        tmpOutput[index].Output_type = value
        setOutput(tmpOutput)
    }
    const handleOutputName = (index: number, value: string) =>{
        const tmpOutput=[...Output]
        tmpOutput[index].Output_name = value
        setOutput(tmpOutput)
    }
    const handleOutputdescriptiption = (index: number, value: string) =>{
        const tmpOutput=[...Output]
        tmpOutput[index].Output_description = value
        setOutput(tmpOutput)
    }
    const handleOutputAmount = (index: number, value: number) =>{
        const tmpOutput=[...Output]
        tmpOutput[index].Output_amount = value
        setOutput(tmpOutput)
    }
    const handleOutputUnit = (index: number, value: string) =>{
        const tmpOutput=[...Output]
        tmpOutput[index].Output_unit = value
        setOutput(tmpOutput)
    }

    //outcomeHandle
    const handleOutcomeName = (index: number, value: string) =>{
        const tmpOutCome=[...Outcome]
        tmpOutCome[index].Outcome_name = value
        setOutcome(tmpOutCome)
    }
    const handleOutcomeAmount= (index: number, value: number) =>{
        const tmpOutCome=[...Outcome]
        tmpOutCome[index].Outcome_amount = value
        setOutcome(tmpOutCome)
    }
    const handleOutcomeUnit= (index: number, value: string) =>{
        const tmpOutCome=[...Outcome]
        tmpOutCome[index].Outcome_unit = value
        setOutcome(tmpOutCome)
    }
    const handleOutcomeDescription= (index: number, value: string) =>{
        const tmpOutCome=[...Outcome]
        tmpOutCome[index].Outcome_description = value
        setOutcome(tmpOutCome)
    }
    const handleOutcomeBenefitor = (index: number, value: string) =>{
        const tmpOutCome=[...Outcome]
        tmpOutCome[index].Outcome_Benefitor = value
        setOutcome(tmpOutCome)
    }

    useEffect(()=>{
        GetDefinition();
        getData();
      },[])
    

    return(
        <div style={{
            padding:15
          }}>
            <h1 className="text-3xl font-semibold ">แบบฟอร์มเสนอโครงการงานวิจัยและนวัตกรรม</h1>  
      <p>เพื่อขอรับเงินทุนสนับสนุนงานวิจัยและนวัตกรรมจากมหาวิทยาลัยวงษ์ชวลิตกุล</p>
      <br/>
          <hr/>
          <br/>
            <h2 className="text-3xl font-bold ">ส่วนที่ 4 ผลผลิต ผลลัพธ์ และผลกระทบ</h2>
          <hr/>
          <br/>
            
        <Form 
        form={form}
        onFinish={handleFinish}>
        <Flex justify='space-between'><p className="font-semibold" style={{marginBottom:10}}><u>ผลผลิตที่คาดว่าจะได้รับ (Output)</u></p>
        <Button onClick={handleOutput}>เพิ่มข้อมูล</Button></Flex>
        <Collapse
            bordered={false}
            defaultActiveKey={['0']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            style={{ background: token.colorBgContainer }}
            items={getItems(panelStyle)}
        />
        <Table 
    columns={[
        {
            title: 'ข้อ',
            dataIndex: 'index',
            fixed: 'left', 
            className: 'fixed-column',
            render: (_, record) => <p>{record.index + 1}</p>
        },
        {
            title: 'ผลผลิต',
            dataIndex: 'Output_name',
            width: 400, 
            render: (text, record, index) => (
                <TextArea 
                    value={record.Output_name}
                    onChange={(e) => handleOutputName(index, e.target.value)}
                    autoSize
                />
            )
        },
        {
            title: 'ประเภทผลผลิต',
            dataIndex: 'Output_type',
            render: (_, record, index) => (
                <Select
                    style={{ width: 400 }}
                    value={record.Output_type}
                    onChange={(value) => handleOutputType(index, value)}
                    options={[
                        {
                            title: 'กำลังคน หรือหน่วยงาน ที่ได้รับการพัฒนาทักษะ',
                            value: 'กำลังคน หรือหน่วยงาน ที่ได้รับการพัฒนาทักษะ'
                        },{
                            title: 'ต้นฉบับบทความวิจัย (Manuscript)',
                            value:'ต้นฉบับบทความวิจัย (Manuscript)'
                        },{
                            title: 'หนังสือ',
                            value:'หนังสือ'
                        },{
                            title: 'ต้นแบบผลิตภัณฑ์ หรือ เทคโนโลยี/กระบวนการใหม่ หรือนวัตกรรมทางสังคม',
                            value:'ต้นแบบผลิตภัณฑ์ หรือ เทคโนโลยี/กระบวนการใหม่ หรือนวัตกรรมทางสังคม'
                        },{
                            title: 'ทรัพย์สินทางปัญญา',
                            value:'ทรัพย์สินทางปัญญา'
                        },{
                            title: 'เครื่องมือ และโครงสร้างพื้นฐาน (Facilities and Infrastructure)',
                            value:  'เครื่องมือ และโครงสร้างพื้นฐาน (Facilities and Infrastructure)'
                        },{
                            title: 'ฐานข้อมูล ระบบและกลไก  หรือมาตรฐาน',
                            value: 'ฐานข้อมูล ระบบและกลไก  หรือมาตรฐาน'
                        },{
                            title: 'เครือข่าย',
                            value: 'เครือข่าย'
                        },{
                            title: 'การลงทุนวิจัยและนวัตกรรม',
                            value: 'การลงทุนวิจัยและนวัตกรรม'
                        },{
                            title: 'ข้อเสนอแนะเชิงนโยบาย (Policy Recommendation) และมาตรการ (Measures)',
                            value: 'ข้อเสนอแนะเชิงนโยบาย (Policy Recommendation) และมาตรการ (Measures)'
                        }
                ]}
                />
            )
        },
        {
            title: 'รายละเอียดของผลผลิต',
            width:400,
            render: (text, record, index) => (
                <TextArea 
                    value={record.Output_description} 
                    onChange={(e) => handleOutputdescriptiption(index, e.target.value)}
                    autoSize
                />
            )
        },
        {
            title: 'จำนวนนำส่ง',
            dataIndex: 'Output_amount',
            width: 150,
            render: (text, record, index) => (
                <InputNumber 
                    value={record.Output_amount}
                    min={0}
                    onChange={(value) => handleOutputAmount(index, value ?? 0)}
                />
            )
        },
        {
            title: 'หน่วยนับ',
            width: 200,
            dataIndex: 'Output_unit',
            render: (text, record, index) => (
                <Input
                    value={record.Output_unit}
                    onChange={(e) => handleOutputUnit(index, e.target.value)} 
                />
            )
        },
        {
            title: '',
            width: 100,
            key: 'action',
            fixed: 'right',
            className: 'fixed-column',
            render: (_, record, index) => (
                <Button
                    onClick={() => {
                        const tmp = Output
                            .filter(item => item.index !== record.index)
                            .map((item, idx) => ({
                                ...item,
                                index: idx,
                            }));
                        setOutput(tmp);
                    }}
                    danger
                >
                    <DeleteOutlined />
                </Button>
            )}]}
            locale={{
                emptyText: (
                  <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                ),
              }}
            scroll={{ x: 'max-content' }}
            dataSource={Output}
            />
        
        <br/>
        
        <br/>
        <Flex justify='space-between'><p className="font-semibold" style={{marginBottom:10}}><u>ผลลัพธ์ที่คาดว่าจะเกิดขึ้น (Expected Outcomes)</u></p>
        <Button onClick={handleOutcome}>เพิ่มข้อมูล</Button></Flex>
        <Collapse
            bordered={false}
            defaultActiveKey={['0']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            style={{ background: token.colorBgContainer }}
            items={getOutcomes(panelStyle)}
        />
        <Table columns={[
            {
                title: 'ข้อ',
                dataIndex: 'index',
                fixed: 'left', 
                className: 'fixed-column',
                render: (_, record) => <p>{record.index + 1}</p>
            },
            {
                title:'ผลที่คาดว่าจะเกิดขึ้น',
                width:400,
                dataIndex:'Outcome_name',
                render:(_,record,index)=>(
                    <><Select
                        style={{width:400}}
                        value={record.Outcome_name}
                        onChange={(value) => handleOutcomeName(index, value)}
                        options={[
                            {
                                value:'ผลงานตีพิมพ์ (Publications)',
                                label:'ผลงานตีพิมพ์ (Publications)'
                            },{
                                value:'การอ้างอิง (Citations)',
                                label:'การอ้างอิง (Citations)'
                            },{
                                value:'เครื่องมือและระเบียบวิธีการวิจัย (Research Tools and Methods)',
                                label:'เครื่องมือและระเบียบวิธีการวิจัย (Research Tools and Methods)'
                            },{
                                value:'ฐานข้อมูลและแบบจำลองวิจัย(Research Databases and Models)',
                                label:'ฐานข้อมูลและแบบจำลองวิจัย(Research Databases and Models)'
                            },
                            {
                                value:'ความก้าวหน้าในวิชาชีพของบุคลากรด้านวิทยาศาสตร์วิจัยและนวัตกรรม (Next Destination)',
                                label:'ความก้าวหน้าในวิชาชีพของบุคลากรด้านวิทยาศาสตร์วิจัยและนวัตกรรม (Next Destination)'
                            },{
                                value:'รางวัลและการยอมรับ (Awards and Recognitions)',
                                label:'รางวัลและการยอมรับ (Awards and Recognitions)'
                            },
                            {
                                value:'การใช้ประโยชน์จากเครื่องมือ อุปกรณ์ห้องวิจัยและโครงสร้างพื้นฐาน (Use of Facilities and Resources)',
                                label:'การใช้ประโยชน์จากเครื่องมือ อุปกรณ์ห้องวิจัยและโครงสร้างพื้นฐาน (Use of Facilities and Resources)'
                            }
                            ,{
                                value:'ทรัพย์สินทางปัญญา การขึ้นทะเบียนพันธุ์ พืชและพันธุ์สัตว์ และการอนุญาตให้ใช้สิทธิ (Intellectual property, Registered Plants Varieties and Animals Breeding and Licensing)',
                                label:'ทรัพย์สินทางปัญญา การขึ้นทะเบียนพันธุ์ พืชและพันธุ์สัตว์ และการอนุญาตให้ใช้สิทธิ (Intellectual property, Registered Plants Varieties and Animals Breeding and Licensing)'
                            }
                            ,{
                                value:'การถ่ายทอดเทคโนโลยี (Technology Transfer)',
                                label:'การถ่ายทอดเทคโนโลยี (Technology Transfer)'
                            }
                            ,{
                                value:'ผลิตภัณฑ์และกระบวนการ บริการ และการ รับรองมาตรฐานใหม่ (New Products/Processes, New Services and New Standard Assurances)',
                                label:'ผลิตภัณฑ์และกระบวนการ บริการ และการ รับรองมาตรฐานใหม่ (New Products/Processes, New Services and New Standard Assurances) '
                            }
                            ,{
                                value:'ทุนวิจัยต่อยอด (Further Funding) ',
                                label:'ทุนวิจัยต่อยอด (Further Funding) '
                            }
                            ,{
                                value:'ความร่วมมือหรือหุ้นส่วน ความร่วมมือ (Collaborations and Partnerships)',
                                label:'ความร่วมมือหรือหุ้นส่วน ความร่วมมือ (Collaborations and Partnerships)'
                            }
                            ,{
                                value:'การผลักดันนโยบาย แนวปฏิบัติ แผนและกฎระเบียบ (Influence on Policy, Practice, Plan and Regulations)',
                                label:'การผลักดันนโยบาย แนวปฏิบัติ แผนและกฎระเบียบ (Influence on Policy, Practice, Plan and Regulations)'
                            }
                            ,{
                                value:'กิจกรรมสร้างการมีส่วนร่วม (Engagement Activities)',
                                label:'กิจกรรมสร้างการมีส่วนร่วม (Engagement Activities)'
                            }
                        ]}
                    /></>
                )
            },
            {
                title:'จำนวนนำส่ง',
                dataIndex:'Outcome_amount',
                width: 150,
                render:(_,record,index)=>(
                    <><InputNumber value={record.Outcome_amount}
                    min={0}
                    onChange={(value)=>handleOutcomeAmount(index,value??0)}
                    /></>
                )
            },
            {
                title:'หน่วยนับ',
                dataIndex:'Outcome_unit',
                width: 150,
                render:(_,record,index)=>(
                    <><Input
                    value={record.Outcome_unit}
                    onChange={(e)=>handleOutcomeUnit(index,e.target.value)}
                    /></>
                )
            },
            {
                title:'รายละเอียดของผลลัพธ์',
                dataIndex:'Outcome_description',
                render:(text,record,index)=>(
                    <><TextArea
                    value={record.Outcome_description}
                    onChange={(e)=>handleOutcomeDescription(index,e.target.value)}
                    autoSize/></>
                )
            },
            {
                title:'ผู้ใช้ประโยชน์/ผู้ได้รับผลประโยชน์',
                dataIndex:'Outcome_Benefitor',
                render:(_,record,index)=>(
                    <><TextArea 
                    value={record.Outcome_Benefitor}
                    onChange={(e)=>handleOutcomeBenefitor(index,e.target.value)}
                    autoSize/></>
                )
            },{
                title:'',
                width: 100,
                key: 'action',
                fixed: 'right',
                className: 'fixed-column',
                render:(_,record)=>(
                    <><Button 
                    onClick={()=>{
                        const tmp = Outcome
                        .filter((item) => item.index !== record.index) // Remove the selected item
                              .map((item, idx) => ({
                                ...item,
                                index: idx, // Reset the index to keep it sequential
                              }));
                        setOutcome(tmp)
                    }}
                    danger><DeleteOutlined /></Button></>
                )
            }
        ]} 
        locale={{
            emptyText: (
              <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
            ),
          }}
        scroll={{ x: 'max-content' }}
        dataSource={Outcome}/>
        <br/>
        
        
        <div>
      <p className="font-semibold">
        <u>ผลกระทบ (Expected Impacts) ที่คาดว่าจะเกิดขึ้น (เลือกได้มากกว่า 1 ข้อ / กรุณากรอกรายละเอียดประกอบ)</u>
      </p>

        <Checkbox
        checked={Academic} onClick={() => SetAcademic(!Academic)}
        style={{marginLeft:20}} >ด้านวิชาการ</Checkbox>
        {Academic && 
        <Form.Item name='academic_impacts'   style={{marginLeft:50}}>
            <TextArea placeholder="กรุณากรอกข้อมูลในช่องนี้" autoSize/>
            </Form.Item>}
            <br/>
        
        <Checkbox checked={Social} onClick={() => SetSocial(!Social)}
        style={{marginLeft:20}}>ด้านสังคม</Checkbox>
        {Social && <Form.Item name='social_impacts'  style={{marginLeft:50}}><TextArea placeholder="กรุณากรอกข้อมูลในช่องนี้" autoSize/></Form.Item>}
        <br/>

        
        <Checkbox checked={PublicSo} onClick={() => SetPublicSo(!PublicSo)} style={{marginLeft:20}}>ด้านสาธารณะ</Checkbox>
        {PublicSo && <Form.Item name='public_impacts'  style={{marginLeft:50}}><TextArea placeholder="กรุณากรอกข้อมูลในช่องนี้" autoSize/></Form.Item>}
        <br/>


        <Checkbox checked={City} onClick={() => SetCity(!City)} style={{marginLeft:20}}>ด้านชุมชนและพื้นที่</Checkbox>
        {City && <Form.Item name='city_impacts'   style={{marginLeft:50}}><TextArea placeholder="กรุณากรอกข้อมูลในช่องนี้" autoSize/></Form.Item>}
        <br/>

        <Checkbox checked={Environment} onClick={() => SetEnvironment(!Environment)} style={{marginLeft:20}}>ด้านสิ่งแวดล้อม</Checkbox>
        {Environment && <Form.Item name='environment_impacts'  style={{marginLeft:50}}><TextArea placeholder="กรุณากรอกข้อมูลในช่องนี้" autoSize/></Form.Item>}
        <br/>

        <Checkbox checked={Policy} onClick={() => SetPolicy(!Policy)} style={{marginLeft:20}}>ด้านนโยบาย</Checkbox>
        {Policy && <Form.Item name='policy_impacts'   style={{marginLeft:50}}><TextArea placeholder="กรุณากรอกข้อมูลในช่องนี้" autoSize/></Form.Item>}
        <br/>


        <Checkbox checked={Economy} onClick={() => SetEconomy(!Economy)} style={{marginLeft:20}}>ด้านเศรษฐกิจ</Checkbox>
        {Economy && <Form.Item name='economy_impacts'   style={{marginLeft:50}}><TextArea placeholder="กรุณากรอกข้อมูลในช่องนี้" autoSize/></Form.Item>}
        <br/>

    </div>

        <Flex justify="center"><Button type="primary" 
              style={{
                backgroundColor: '#33b249',
                color: 'white',
                borderColor: '#33b249',
              }}
              htmlType='submit'
              >บันทึก</Button></Flex>
          <br/>
        
        <Flex justify="space-between" align="center" style={{ width: '100%' }}>
              <div style={{ flex: 1, textAlign: 'left' }}>
              <Button type="primary" onClick={()=>{setopen(true)}}>กลับไปหน้าก่อน</Button>
              </div>
              <Modal
              title="ยืนยันการกลับไปหน้าก่อน"
              width={'50vw'}
              open={open}
              onCancel={handleCancel}
              footer={[
                <><Button key="back" onClick={handleCancel}>
                  ยกเลิก
                </Button>
                <Button  key="go" danger type="primary" href={`/VRIIS/BudgetReqDetail/${project_id}`}>
                  ตกลง
                </Button>
                </>
              ]}>
              การตกลงจะนำทางท่านไปสู่ส่วนก่อนหน้านี้โดยไม่บันทึกข้อมูลที่ท่านกรอกไปแล้ว ท่านมั่นใจหรือไม่ที่จะกลับไปส่วนก่อน
              </Modal>
              <div style={{ flex: 1, textAlign: 'center' }}>
                <Button type="primary" htmlType='submit'  onClick={handleMainInfo}>บันทึกแล้วกลับหน้าหลัก</Button> 

              </div>
              <div style={{ flex: 1, textAlign: 'right' }}>
              <Button type="primary" htmlType='submit' onClick={handleNextPart} style={{backgroundColor:'#33b249',color:'white'}}>บันทึกแล้วไปส่วนที่ 5</Button>

              </div>
            </Flex>
        </Form>
        </div>
    )
}